class ProductTabs extends HTMLElement {
  constructor() {
    super()

    this.triggers = this.querySelectorAll('.js-tabs-trigger');
    this.card = this.querySelectorAll('.js-grid__item-desktop');
    this.activeClass = 'is-active';
    this.changeTab = this.changeTab.bind(this);
  }

  connectedCallback() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', event => this.changeTab(event));

      trigger.addEventListener('keydown', event => {
        if (event.code === 'Space' || event.code === 'Enter') {
          this.changeTab(event);
        }
      })
    });

    // Register IntersectionObserver
    const options = {
      threshold: 0.4,
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        let id = entry.target.dataset.listId

        if (entry.isIntersecting && !document.body.classList.contains('scrolling')) {
          const activeElements = this.querySelectorAll(`.${this.activeClass}`);
          activeElements.forEach(tab => {
            tab.classList.remove(this.activeClass);
          });
          this.querySelector(`[id="${id}"]`).classList.add(this.activeClass);
        }
      })
    }, options)

    this.card.forEach(list => {
      observer.observe(list);
    })
  }

  changeTab(event) {
    const target = event.target.closest('li');
    const id = target.getAttribute('id');
    const activeElements = this.querySelectorAll(`.${this.activeClass}`);

    document.body.className += ' scrolling';

    activeElements.forEach(tab => {
      tab.classList.remove(this.activeClass);
    });

    target.classList.add(this.activeClass);
    this.querySelector(`[data-anchor-id="${id}"]`).scrollIntoView({ behavior: "smooth", block: "start" });

    let scrollTimeout;
    addEventListener('scroll', function(e) {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          document.body.classList.remove( 'scrolling' );
        }, 100);
    });
  }
}

customElements.define('product-tabs', ProductTabs)